export default abstract class BaseContent {
    public abstract loadResources(paths): Promise<{}>;
    public abstract play(): Promise<{}>;
    protected state: any = {};

    public setState(object: any): void {
        this.state = { ...this.state, ...object };
    }
}
